import { InferType, object, string } from 'yup'

import { EMAIL_REGEX } from '@/app/constants/regex'
import {
  REQUIRED_EMAIL_FIELD_MESSAGE,
  REQUIRED_SUM_FIELD_MESSAGE
} from '@/app/constants/validation'
import { formatNumber } from '@/utils/string-formatting'

const WRONG_EMAIL = 'Введен некорректный email'
const MAX_AMOUNT = 1_000_000
const AMOUNT_EXCEEDED = 'Сумма оплаты не более 1 000 000 ₽'

export const paymentSchema = object().shape({
  amount: string()
    .transform((_, originalValue) => formatNumber(originalValue))

    .when('$isPrepayment', ([isPrepayment], schema) => {
      return isPrepayment
        ? schema
            .required(REQUIRED_SUM_FIELD_MESSAGE)
            .test(
              'not-zero',
              REQUIRED_SUM_FIELD_MESSAGE,
              value => Number(value) > 0
            )
            .test('max', AMOUNT_EXCEEDED, function (value) {
              const num = Number.parseFloat(value)
              return !Number.isNaN(num) && num <= MAX_AMOUNT
            })
        : schema
    }),
  email: string()
    .required(REQUIRED_EMAIL_FIELD_MESSAGE)
    .matches(EMAIL_REGEX, WRONG_EMAIL)
})

export type PaymentFormData = InferType<typeof paymentSchema>
